import { MaggieHttp } from '../MaggieHttp';

export interface DealDocDTO {
  id: number;
  roundId: number | null;
  companyId: number | null;
  documentType: 'captable' | 'closing_doc';
  fileName: string;
  fileSize: string;
  contentType: string;
  uploadedBy: string;
  uploadSource: 'maggie' | 'starbreaker';
  createdAt: string;
  updatedAt: string;
}

export interface CompanyDealDocsResponse {
  companyDocs: DealDocDTO[];
  roundDocs: Array<{
    roundId: number;
    roundName: string;
    roundDate: string | null;
    documents: DealDocDTO[];
  }>;
}

export interface ReassignDealDocPayload {
  targetRoundId?: number | null;
  targetCompanyId?: number | null;
}

export const getAllCompanyDealDocs = async (companyId: number): Promise<CompanyDealDocsResponse> => {
  const { data } = await MaggieHttp.maggie.get<CompanyDealDocsResponse>(
    `/round/cs/company/${companyId}/all-documents`
  );
  return data;
};

export const reassignDealDocument = async (
  documentId: number,
  payload: ReassignDealDocPayload
): Promise<DealDocDTO> => {
  const { data } = await MaggieHttp.maggie.put<ReassignDealDocPayload, DealDocDTO>(
    `/round/cs/documents/${documentId}/reassign`,
    payload
  );
  return data;
};

// Helper function to get rounds for a company
export const getRounds = async (companyId: number) => {
  const { data } = await MaggieHttp.maggie.get<
    Array<{
      id: number;
      name: string;
      roundDate: string | null;
      /** The round's InvestmentRound stage, and the event type that stage maps to. */
      stageName: string | null;
      stageEventType: string | null;
    }>
  >(`/round?companyId=${companyId}`);
  return data;
};
